<template>
  <div>
    <el-row>
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" style="overflow: hidden;margin-top:30px"
        class="demo-ruleForm">
        <el-col :span="5">
          <el-form-item label="国家" prop="countryMark">
            <el-select v-model="ruleForm.countryMark" placeholder="请选择国家" filterable>
              <el-option v-for="item in countryList" :key="item.id" :label="item.countryName" :value="item.countryCode"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="退仓状态" prop="exitStatus">
            <el-select v-model="ruleForm.exitStatus" placeholder="请选择退仓状态">
              <el-option label="退仓" value="退仓"></el-option>
              <el-option label="退仓上架" value="退仓上架"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="重派状态" prop="status">
            <el-select v-model="ruleForm.status" placeholder="请选择重派状态">
              <el-option label="未处理" value="0"></el-option>
              <el-option label="重派中" value="1"></el-option>
              <el-option label="重派完成" value="2"></el-option>
              <el-option label="销毁" value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="渠道" prop="channelType">
            <el-select v-model="ruleForm.channelType" filterable>
              <el-option v-for="item in listLogistics"
                :key="item.id"
                :label="item.itemTypeName"
                :value="item.itemTypeId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="时间搜索类型" prop="timeType">
            <el-select v-model="ruleForm.timeType" placeholder="请选择时间搜索类型">
              <el-option label="创建时间" value="1"></el-option>
              <el-option label="重派时间" value="2"></el-option>
              <el-option label="销毁时间" value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="开始日期" prop="startTime">
            <el-date-picker v-model="ruleForm.startTime" @change="startTime" align="right" type="date"
              placeholder="选择开始日期" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="结束日期" prop="endTime">
            <el-date-picker v-model="ruleForm.endTime" @change="endTime" align="right" type="date"
              placeholder="选择结束日期" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="SKU" prop="sellerSku">
            <el-input v-model.trim="ruleForm.sellerSku" placeholder="请输入SKU" style="width: 65%;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="searchStr" style="margin-left: 0px;">
            <el-input v-model.trim="ruleForm.searchStr" placeholder="退件条码、原转号、渠道ID" style="width: 65%;"></el-input>
            <el-button type="primary" @click="search2" style="margin-left:20px;">搜索</el-button>
            <el-button type="primary" @click="resetFprm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>

    <div class="table-body">
      <!-- <div class="table-batch">
        <el-button type="primary" @click="dialogVisible=true">
          批量导入退件
        </el-button>
      </div> -->
      <div class="table-list">
        <el-table width="100%" :data="tableData" border :header-cell-style="{ textAlign: 'center' }" v-loading="loading">

          <el-table-column align="left" label="商品信息" width="280">
            <template slot-scope="scope">
              <div
                class="details"
                v-if="scope.row.orderItems"
              >
                <div class="details_left">
                  <el-popover
                    trigger="hover"
                    placement="right"
                    prop="orderItems.imageUrl"
                    v-if="scope.row.orderItems.imageUrl"
                  >
                    <img
                      referrer="no-referrer|origin|unsafe-url"
                      :src="scope.row.orderItems.imageUrl"
                      alt
                      style="width:500px;height:500px;"
                    />
                    <div class="scope_img" slot="reference">
                      <img referrer="no-referrer|origin|unsafe-url" :src="scope.row.orderItems.imageUrl" alt />
                    </div>
                  </el-popover>
                  <el-button
                    type="text"
                    size="mini"
                    v-else
                    @click="getOriginalImg(item)"
                    style="padding: 0;"
                    >查看原图</el-button
                  >
                </div>
                <div class="details_right">
                  <div
                    style="width: 100%;"
                    v-if="scope.row.orderItems.title !== null"
                    class="textlang"
                    :title="scope.row.orderItems.title"
                  >
                    <strong style="color:black">商品简称:</strong> {{ scope.row.orderItems.title }}
                  </div>
                  <div style="width: 100%;color:#dc143c" v-show="scope.row.orderItems.systemSku">
                    <strong>系统SKU:</strong> {{ scope.row.orderItems.systemSku }}
                  </div>
                  <div style="width: 100%;">
                    <strong style="color:black">SKU:</strong> {{ scope.row.orderItems.sellerSKU }}
                  </div>
                  <div style="width: 100%;" v-show="scope.row.orderItems.productSku">
                    <strong style="color:black">产品SKU:</strong> {{ scope.row.orderItems.productSku }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="productDescription" label="订单信息" align="left" width="220">
				<template slot-scope="scope">
					<div
						class="details"
					>
						<div class="details_right" style="width: 100%">
							<div style="width: 100%;">
								<strong style="color:black">原订单号:</strong> {{ scope.row.orderInfo.amazonOrderId }}
							</div>
							<div style="width: 100%;">
								<strong style="color:black">原订单ID:</strong> {{ scope.row.orderInfo.id }}
							</div>
							<div style="width: 100%;">
								<strong style="color:black">退件条码:</strong> {{ scope.row.returnBarcode }}
							</div>
							<div style="width: 100%;">
								<strong style="color:black">原转单号:</strong> {{ scope.row.oldConveyNumber }}
							</div>
							<div style="width: 100%;">
								<strong style="color:black">渠道ID:</strong> {{ scope.row.orderChannelId }}
							</div>
						</div>
					</div>
				</template>
			</el-table-column> -->

          <!-- <el-table-column prop="productSimpleName" label="采购需求" align="center" width="150">
            <template slot-scope="scope">
              <div
                class="details"
                v-for="(item, index) in scope.row.orderInfo.purchaseDemands"
                :key="index"
              >
                <div class="details_right" style="width: 100%">
                  <div style="width: 100%;">
                    {{ item.purchaseDemand }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="countryName" label="国家" align="center" width="180"></el-table-column>
          <el-table-column prop="count" label="总计退仓数量" align="center"></el-table-column>
          <el-table-column prop="reassignCount" label="重派数量" align="center"></el-table-column>
          <el-table-column prop="destroyCount" label="销毁数量" align="center"></el-table-column>
          <el-table-column prop="remainCount" label="剩余数量" align="center"></el-table-column>
          <el-table-column prop="destroyTime" label="最早批次销毁时间" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.codReturns.length">{{scope.row.codReturns[0].destroyTime}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="primary" @click="showDetail(scope.row)">查看匹配记录</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    
    <div class="page">
      <el-pagination style="margin-right:200px;" layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[20, 50, 100, 200]" :page-size="pagesize" :current-page="currentPage" :total="total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>
    <Addinventory ref="Addinventory" @Addinventory="search" />
    <buildbyoneself ref="buildbyoneself" @Editinventory="search" />

    <el-dialog
      title="导入COD退件"
      :visible.sync="dialogVisible"
      width="30%"
      @close="handleUploadExcelDialogClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
    >
      <el-row type="flex" align="middle">
        <upload-excel-component :on-success="handleUploadExcelSuccess"/>
        <el-button style="margin-left: 10px;" @click="downloadTemplate">下载模板</el-button>
      </el-row>
      <div class="file-box">
        <span style="color: red">注意：时间格式按照“2022/10/10”填写</span>
      </div>
      <div class="file-box">
        <div v-for="(item, index) in listFile" :key="index">{{ `${ index + 1 }. ${ item.fileName }` }}</div>
      </div>
      <div class="file-box" v-show="errorList">
        <span><span style="color: red">导入异常运单号：</span>{{ errorList }}</span>
      </div>
      <div slot="footer">
        <el-button
          size="small"
          @click="handleUploadExcelSubmit"
          :loading="btnLoading"
        >确定导入
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看详情" :visible.sync="detailVisible" width="60%">
      <div class="box-card">
        <template v-if="detailData.orderInfo">
          <el-row style="margin-bottom: 14px;">
            <el-col :span="8">
              <strong>原订单ID：</strong>{{detailData.orderInfo.id}}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>原订单号：</strong>{{detailData.orderInfo.amazonOrderId}}
            </el-col>
          </el-row>
          <div v-for="(item,index) in detailData.orderInfo.orderItems" :key="index+'q'">
            <el-row class="custom-container">
              <el-col :span="4">
                <el-image
                  style="width: 100%; height: 100%;"
                  :src="item.imageUrl"
                  :z-index="2200"
                  :preview-src-list="item.imageUrl.split(',')"
                ></el-image>
              </el-col>
              <el-col :span="19" :offset="1" style="padding-top: 30px">
                <div class="inform flex">
                  <div class="title">商品简称：{{ item.title }}</div>
                </div>
                <div class="inform flex">
                  <div class="title">商品主SKU：{{ item.systemSku }}</div>
                </div>
                <div class="inform flex">
                  <div class="title">商品SKU别名：{{ item.sellerSKU }}</div>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="8">
              <strong>国家：</strong>{{detailData.orderInfo.address.countryCode}}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>退件条码：</strong>{{detailData.returnBarcode}}
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;">
            <el-col :span="8">
              <strong>退件单号(原转单号)：</strong>{{detailData.oldConveyNumber}}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>重派状态：</strong>{{statusFont[detailData.status]}}
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;">
            <el-col :span="8">
              <strong>重派时间：</strong>{{detailData.reassignTime}}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <!-- <el-col :span="12">
              <strong>退件抵扣：</strong>{{100.00}}
            </el-col> -->
          </el-row>
        </template>

        <template v-if="detailData.newOrderInfo">
          <el-divider></el-divider>
          <el-row style="margin-bottom: 14px;">
            <el-col :span="8">
              <strong>重派订单ID：</strong>{{detailData.newOrderInfo.id}}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>重派订单号：</strong>{{detailData.newOrderInfo.amazonOrderId}}
            </el-col>
          </el-row>
          <div v-for="(item,index) in detailData.newOrderInfo.orderItems" :key="index+'w'">
            <el-row class="custom-container">
              <el-col :span="4">
                <el-image
                  style="width: 100%; height: 100%;"
                  :src="item.imageUrl"
                  :z-index="2200"
                  :preview-src-list="item.imageUrl.split(',')"
                ></el-image>
              </el-col>
              <el-col :span="19" :offset="1" style="padding-top: 30px">
                <div class="inform flex">
                  <div class="title">商品简称：{{ item.title }}</div>
                </div>
                <div class="inform flex">
                  <div class="title">商品主SKU：{{ item.systemSku }}</div>
                </div>
                <div class="inform flex">
                  <div class="title">商品SKU别名：{{ item.sellerSKU }}</div>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="8">
              <strong>国家：</strong>{{detailData.newOrderInfo.address.countryCode}}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="8">
              <strong>收件人：</strong>{{detailData.newOrderInfo.address.name}}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>收件地址1：</strong>{{detailData.newOrderInfo.address.addressLine1}}
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="8">
              <strong>收件地址2：</strong>{{detailData.newOrderInfo.address.addressLine2}}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>收件地址3：</strong>{{detailData.newOrderInfo.address.addressLine3}}
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="8">
              <strong>收件人城市：</strong>{{detailData.newOrderInfo.address.city}}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>收件人州：</strong>{{detailData.newOrderInfo.address.stateOrRegion}}
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="8">
              <strong>收件人电话：</strong>{{detailData.newOrderInfo.address.phone}}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>收件人email：</strong>{{detailData.newOrderInfo.buyerEmail}}
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="8">
              <strong>收件人邮编：</strong>{{detailData.newOrderInfo.address.postalCode}}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="16">
              <strong>代收款金额：</strong>
              <el-input v-model.trim="detailData.newOrderInfo.money.amount" @change="changeAmount(detailData.newOrderInfo.money.amount)" type="number" :min="0" placeholder="请输入代收款金额" style="width:150px"></el-input>
              {{detailData.newOrderInfo.money.currencyCode}}
            </el-col>
            <el-col :span="8">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
          </el-row>
        </template>
        <div slot="footer" class="dialog-footer" style="text-align: right;" v-if="detailData.newOrderInfo">
          <el-button @click="detailVisible=false">取消</el-button>
          <el-button type="primary" @click="submitForm">提交</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
			top="5vh"
			width="86%"
			title="匹配记录"
			:visible.sync="jiluVisibles"
			append-to-body
		>
			<el-input
				v-model.trim="searchString"
				placeholder="退件条码、原转单号、渠道ID"
				style="width:22%;margin-right: 20px;"
			></el-input>
			<el-button
				type="primary"
				style="margin-left:15px;"
				@click="handlejiluTable"
				>搜索</el-button
			>
			<el-button
				style="margin-left:15px;"
				@click="handleResetTable"
				>重置</el-button
			>
			<el-table width="100%" :data="jiluDialogList" border :header-cell-style="{ textAlign: 'center' }" v-loading="jiluDialogLoading" max-height="500px" style="margin-top: 15px">
        <el-table-column width="80" prop="id" label="退仓ID" align="center" />

        <el-table-column align="left" label="商品信息" width="250">
          <template slot-scope="scope">
            <template v-if="scope.row.newOrderInfo">
              <div
                class="details"
                v-for="(item, index) in scope.row.newOrderInfo.orderItems"
                :key="index"
              >
                <div class="details_left">
                  <el-popover
                    trigger="hover"
                    placement="right"
                    prop="orderItems.imageUrl"
                    v-if="item.imageUrl"
                  >
                    <img
                      referrer="no-referrer|origin|unsafe-url"
                      :src="item.imageUrl"
                      alt
                      style="width:500px;height:500px;"
                    />
                    <div class="scope_img" slot="reference">
                      <img referrer="no-referrer|origin|unsafe-url" :src="item.imageUrl" alt />
                    </div>
                  </el-popover>
                  <el-button
                    type="text"
                    size="mini"
                    v-else
                    @click="getOriginalImg(item)"
                    style="padding: 0;"
                    >查看原图</el-button
                  >
                </div>
                <div class="details_right">
                  <div
                    style="width: 100%;"
                    v-if="item.title !== null"
                    class="textlang"
                    :title="item.title"
                  >
                    <strong style="color:black">商品简称:</strong> {{ item.title }}
                  </div>
                  <div style="width: 100%;" v-show="item.systemSku">
                    <strong style="color:black">系统SKU:</strong> {{ item.systemSku }}
                  </div>
                  <div style="width: 100%;">
                    <strong style="color:black">SKU:</strong> {{ item.sellerSKU }}
                  </div>
                  <div style="width: 100%;" v-show="item.productSku">
                    <strong style="color:black">产品SKU:</strong> {{ item.productSku }}
                  </div>
                </div>
              </div>
            </template>
          </template>
        </el-table-column>

        <el-table-column prop="productDescription" label="重派订单号/重派订单ID" align="left">
          <template slot-scope="scope">
            <div
              class="details"
              v-if="scope.row.newOrderInfo"
            >
              <div class="details_right" style="width: 100%">
                <div style="width: 100%;">
                  <strong style="color:black">重派订单号:</strong> {{ scope.row.newOrderInfo.amazonOrderId }}
                </div>
                <div style="width: 100%;">
                  <strong style="color:black">重派订单ID:</strong> {{ scope.row.newOrderInfo.id }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="productSimpleName" label="采购需求" align="center" width="150">
          <template slot-scope="scope">
            <template v-if="scope.row.orderInfo">
              <div
                class="details"
                v-for="(item, index) in scope.row.orderInfo.purchaseDemands"
                :key="index"
              >
                <div class="details_right" style="width: 100%">
                  <div style="width: 100%;">
                    {{ item.purchaseDemand }}
                  </div>
                </div>
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="productSimpleName" label="核对详情" align="center" width="150">
          <template slot-scope="scope">
            <template v-if="scope.row.orderInfo">
              <div
                class="details"
                v-for="(item, index) in scope.row.orderInfo.purchaseDemands"
                :key="index+'vv'"
              >
                <div class="details_right" style="width: 100%">
                  <div
                    style="width: 100%;"
                    v-for="(ele, i) in item.purchaseItems"
                    :key="i+'dd'"
                  >
                    {{ ele.purchaseModel }}
                  </div>
                </div>
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="countryName" label="国家" align="center" width="80"></el-table-column>
        <el-table-column prop="destroyTime" label="销毁时间" align="center"></el-table-column>
        <el-table-column prop="status" label="重派状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="statusType[Number(scope.row.status)]">{{statusFont[Number(scope.row.status)]}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="exitStatus" label="退仓状态" width="100" align="center"></el-table-column>
        <el-table-column prop="reassignTime" label="重派时间" align="center"></el-table-column>
      </el-table>
			<el-pagination
				style="text-align: center;margin-top:10px;"
				@size-change="handleSizeChange2"
				@current-change="handleCurrentChange2"
				:current-page="currentPage2"
				:page-sizes="[20, 50, 100, 200]"
				:page-size="pagesize2"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total2"
			></el-pagination>

			<div slot="footer" class="dialog-footer">
				<div>
					<el-button @click="jiluVisibles = false">关 闭</el-button>
				</div>
			</div>
		</el-dialog>
  </div>
</template>

<script>
// 库存编辑
import buildbyoneself from '../buildbyoneself/buildbyoneself'
// 新增产品库存
import Addinventory from '../buildbyoneself/Addinventory'
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import { ajaxPost, Baseurl } from '../../../api/api/api'
export default {
  name: 'COMparticulars',
  components: {
    buildbyoneself,
    Addinventory,
    UploadExcelComponent
  },
  props: {
    countryList: { type: Array },
    listLogistics: { type: Array }
  },
  data() {
    return {
      currentPage: 1,
      pagesize: 5,
      size: 20,
      total: 0,
      ruleForm: {
        countryMark: '',
        exitStatus: '',
        status: '',
        timeType: '1',
        startTime: '',
        endTime: '',
        searchStr: '',
        sellerSku: '',
        channelType: ''
      },
      tableData: [],
      loading: false,
      statusType: ['info', '', 'success', 'danger'],
      statusFont: ['未处理', '重派中', '重派完成', '销毁'],
      dialogVisible: false,
      btnLoading: false,
      listFile: [],
      returnList: [],
      errorList: '',
      detailVisible: false,
      detailData: {},
      
      cruuentObj: {},
      searchString: '',
      jiluVisibles: false,
      jiluDialogList: [],
      jiluDialogLoading: false,
      currentPage2: 1,
			pagesize2: 20,
			size2: 20,
			total2: 0
    }
  },
  created() {
    this.str = JSON.parse(localStorage.getItem('role'))
    this.search()
  },
  methods: {
    handlejiluTable() {
      this.jiluDialogLoading = true
      // 库存列表sellerSku 
      var obj = {
        page: this.currentPage2,
        size: this.size2,
        searchStr: this.searchString,
        rid: this.str.rid,
        sellerSku: this.cruuentObj.sellerSku,
      }
      ajaxPost(
        Baseurl + 'codReturnController/matchingRecordsPageInfo',
        obj
      ).then((res) => {
        if (res.data.code === 200) {
          this.jiluDialogList = res.data.data.list
          this.total2 = res.data.data.total
        }
        this.jiluDialogLoading = false
      })
    },
    handleResetTable() {
      this.searchString = ''
      this.handlejiluTable()
    },
    handleSizeChange2(val) {
      this.size2 = val
      this.handlejiluTable()
    },
    handleCurrentChange2(val) {
      this.currentPage = val
      this.handlejiluTable()
    },
    changeAmount(num) {
      if (Number(num) < 0) this.detailData.newOrderInfo.money.amount = 0
    },
    submitForm() {
      ajaxPost(
        Baseurl + 'moneyController/updateMoney',
        {id: this.detailData.newOrderInfo.money.id, amount: this.detailData.newOrderInfo.money.amount}
      ).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("提交成功")
          this.detailVisible = false
          this.search()
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    showDetail(data) {
      this.cruuentObj = JSON.parse(JSON.stringify(data))
      this.jiluVisibles = true
      this.handlejiluTable()
      // this.detailVisible = true
      // this.detailData = data
    },
    handleUploadExcelSubmit() {
      this.btnLoading = true
      ajaxPost(
        Baseurl + 'codReturnController/importCodReturn/'+this.str.rid, this.returnList
      ).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("成功导入"+res.data.data.successCount+"条数据")
          if (res.data.data.errorList.length) {
            this.errorList = res.data.data.errorList.join(",")
          } else {
            this.dialogVisible = false
            this.listFile = []
            this.errorList = ''
          }
        } else {
          this.$message.error(res.data.message)
        }
        this.btnLoading = false
      })
    },
    formatDate(numb, format) {
      const old = numb - 1;
      const t = Math.round((old - Math.floor(old)) * 24 * 60 * 60);
      const time = new Date(1900, 0, old, 0, 0, t)
      const year = time.getFullYear() ;
      const month = time.getMonth() + 1 ;
      const date = time.getDate();
      return year + format + (month < 10 ? '0' + month : month) + format + (date < 10 ? '0' + date : date)
    },
    handleUploadExcelSuccess({ results, header, fileName }) {
      this.returnList = results.map(item => ({
        returnBarcode: item.退件条码,
        oldConveyNumber: item.原运单号,
        orderChannelId: item.原订单号,
        exitStatus: item.退仓状态,
        noticeTime: this.formatDate(item.通知时间, '-'),
        destroyTime: this.formatDate(item.销毁时间, '-')
      }))
      this.listFile.push({fileName})
    },
    downloadTemplate() {
      const a = document.createElement('a')
      a.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/COD%E9%80%80%E4%BB%B6%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      a.download = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/COD%E9%80%80%E4%BB%B6%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      a.click()
      this.$message.success('正在下载...')
    },
    handleUploadExcelDialogClose() {
      this.dialogVisible = false
      this.listFile = []
      this.errorList = ''
    },
    Edit(e) {
      this.$refs.buildbyoneself.init(e)
    },
    startTime(val) {
      var d = new Date(val)
      var datetime =
        d.getFullYear() +
        '-' +
        (d.getMonth() + 1) +
        '-' +
        d.getDate() +
        ' 00:00:00'
      this.ruleForm.startTime = datetime
    },
    // 选择结束时间
    endTime(val) {
      var d = new Date(val)
      var datetime =
        d.getFullYear() +
        '-' +
        (d.getMonth() + 1) +
        '-' +
        d.getDate() +
        ' 23:59:59'
      this.ruleForm.endTime = datetime
    },
    search2() {
      this.currentPage = 1
      this.search()
    },
    search() {
      this.loading = true
      // 库存列表
      var obj = {
        page: this.currentPage,
        size: this.size,
        ...this.ruleForm,
        channelType: this.ruleForm.channelType ? Number(this.ruleForm.channelType) : '',
        rid: this.str.rid
      }
      ajaxPost(
        Baseurl + 'codReturnController/statisticCodReturnByAlias',
        obj
      ).then((res) => {
        console.log(res.data);
        if (res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
        }
        console.log(this.tableData);
        this.loading = false
      })
    },
    del(val) {
      this.$confirm(
        '该操作会导致未入库的库存无法正常入库，无法对应，易导致货物丢失，请谨慎操作，是否继续删除？',
        '提示',
        {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning',
        }
      ).then(() => {
        var obj = {
          id: val.id,
        }
        ajaxPost(
          Baseurl + 'inventoryController/updateInventoryStatusById',
          obj
        ).then((res) => {
          if (res.data.code === 200) {
            this.search()
          } else {
            this.$message.error(res.data.data)
          }
        })
      })
    },
    resetFprm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.timeType = '1'
      this.currentPage = 1
      this.search()
    },
    Addinventory() {
      this.$refs.Addinventory.init()
    },
    handleSizeChange(val) {
      this.size = val
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ {
  .layout .layout-section ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #b71e1e;
  }

  .el-form-item__content {
    margin-left: 0px !important;
  }

  .el-divider--horizontal {
    margin: 15px 0;
  }
}

.details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.details_left {
  width: 30%;
  text-align: center;
}
.details_right {
  width: 70%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.table-body {
	width: 100%;
	border: 1px solid #eee;
	overflow: hidden;
}
.table-batch {
  box-sizing: border-box;
  text-align: right;
  padding-right: 20px;
	width: 100%;
	overflow: hidden;
	height: 40px;
	line-height: 40px;
	padding-left: 25px;
}

.information {
  width: 98%;
  overflow: hidden;
  margin-bottom: 50px;
}

.scope_img {
  width: 55px;
  height: 55px;

  img {
    width: 100%;
    height: 100%;
  }
}

.prduct_img {
  width: 300px;
  height: 300px;
}

.padding {
  padding: 5px 0;
}

.line-height {
  line-height: 35px;
}

.page {
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  z-index: 99;
}

.textlang {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.file-box {
  padding-top: 20px;
}
</style>
